import { Payment } from '@apply/api/src/api/PaymentApi';
import { PaymentMethod } from '@apply/constants';

interface PaymentMethodSectionParameters {
    payment: Payment;
}

export const PaymentMethodSection: React.FC<PaymentMethodSectionParameters> = ({ payment }) => {
    const calculateCardType = (status: PaymentMethod): string => {
        switch (status) {
            case PaymentMethod.MasterCard:
                return 'MasterCard';
            case PaymentMethod.Visa:
                return 'Visa';
        }
    };

    return (
        <>
            <div className='payment-edit-section'>Payment Method</div>
            <table>
                <tr>
                    <td className='payment-edit-details-label'>Owner</td>
                    <td className='payment-edit-details-value'>{payment.customerName}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Email</td>
                    <td className='payment-edit-details-value'>{payment.email}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Address</td>
                    <td className='payment-edit-details-value'>
                        {payment.address} / {payment.zipCode}
                    </td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Phone</td>
                    <td className='payment-edit-details-value'>{payment.phone}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>&nbsp;</td>
                    <td className='payment-edit-details-value'>&nbsp;</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Type</td>
                    <td className='payment-edit-details-value'>{calculateCardType(payment.paymentMethod)}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Number</td>
                    <td className='payment-edit-details-value'>•••• {payment.cardLastFourDigits}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Expires</td>
                    <td className='payment-edit-details-value'>{payment.expirationDate}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>&nbsp;</td>
                    <td className='payment-edit-details-value'>&nbsp;</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>GUID</td>
                    <td className='payment-edit-details-value'>{payment.paymentGuid}</td>
                </tr>
            </table>
        </>
    );
};
